export default __webpack_public_path__ + "static/media/hazardous_behavior.c309dedc.png";